import { render, staticRenderFns } from "./HeadlineIcons.vue?vue&type=template&id=4b76baba"
import script from "./HeadlineIcons.vue?vue&type=script&lang=ts"
export * from "./HeadlineIcons.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineIcons.vue?vue&type=style&index=0&id=4b76baba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports